import "./styles.scss";
import { useIntl } from "react-intl";

export interface IHeaderProps {
  onClose: () => void;
}

const Header = ({ onClose }: IHeaderProps) => {
  const intl = useIntl();

  return (
    <div className="contract-details-header">
      <h3 className="contract-details-header__title">
        <span className="rioglyph rioglyph-document contract-details-header__icon"></span>
        {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.header.title" })}
      </h3>
      <div
        className="close-sidebar cursor-pointer"
        onClick={onClose}
        aria-label={intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.header.close" })}
      >
        <span className="rioglyph rioglyph-remove"></span>
      </div>
    </div>
  );
};

export default Header;
